import { tn } from '@/lib/shared/utils/transform-name';

export const mapQuery = <T extends [string, unknown]>(item: T): T => {
  const [key, val] = item;
  const transformedParams = [
    'type',
    'phuketDistrict',
    'samuiDistrict',
    'district',
  ];
  if (transformedParams.includes(key as string) && Array.isArray(val)) {
    return [
      key,
      val.map((v) => {
        if (v === 'flat') {
          return tn('apartment', 'dtu');
        }
        return tn(v, 'dtu');
      }),
    ] as T;
  }
  return item;
};
